import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealMonitoringResponseEntity } from '../../domain/entities/MealMonitoringResponseEntity'
import type { GetMealsMonitoringAdminResponse } from '@/backend/market'
import { MealMonitoringModel } from './MealMonitoringModel'
import type { MealMonitoringEntity } from '../../domain/entities/MealMonitoringEntity'

export class MealMonitoringResponseModel extends MealMonitoringResponseEntity {
  constructor(dataDto: GetMealsMonitoringAdminResponse) {
    super()
    const mealMonitoringModel = dataDto.meals?.map(
      (meal) => new MealMonitoringModel(meal as MealMonitoringEntity)
    )
    mapEntityProperties<MealMonitoringResponseEntity>(this, dataDto, {
      map: {
        meals: mealMonitoringModel
      }
    })
  }
}
